export const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, "");
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return `${r}, ${g}, ${b}`;
};
/**
 * Lightens a hex color by a given percentage towards white.
 *
    const original = "#E31937";
    const lightened = lightenColor(original, 0.85); // 85% towards white
    console.log(lightened); // Output: ~#FFE4E8
 */
export function lightenColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = (num >> 16) + Math.round((255 - (num >> 16)) * percent);
    const g = ((num >> 8) & 0x00ff) + Math.round((255 - ((num >> 8) & 0x00ff)) * percent);
    const b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent);
    return ("#" +
        ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase());
}
export const COLORS = {
    green: "#159E0E", // for delivered
    lavenderPurple: "#AC93F3", // for submit success
    gray: "#7B7B7B",
    lightGray: "A3A3A3", // for undelivered
    softRed: "FF686E", // for failed
    yellow: "#FFB049",
    skyBlue: "#84C1FF",
    dodgerBlue: "#1e90ff",
    brown: "#7f0000", // A52A2A
    navyBlue: "#000080",
    yellowLight: "#ffff00",
    delivered: "#AC93F3",
    inProgress: "#39DDC8",
    scheduled: "#52B3F9",
    expired: "#FFB800",
    orange: "#ff8c00",
    orange2: "#FFA500",
    amber: "#FFB300",
    errorRed: "#C62828",
    red: "#EF4444",
    raspberryPink: "DE3163",
    lightRed: "#F06969",
    // fall back colors
    neutralLight: "#F5F5F5",
    neutralDark: "#404040",
};
export const STATUS_COLOR_MAP = {
    Cancelled: COLORS.gray,
    Delivered: COLORS.green,
    UnDelivered: COLORS.softRed,
    InProgress: COLORS.inProgress,
    Scheduled: COLORS.yellow,
    SubmitFailed: COLORS.lightRed,
    SubmitSuccess: COLORS.lavenderPurple,
    InternalFailure: COLORS.brown,
    Default: COLORS.neutralDark,
    DeliveryPending: COLORS.amber,
    DeliveryTimeout: COLORS.yellowLight,
    Bounced: COLORS.navyBlue,
    INCAPABLE: COLORS.orange2,
    // not in use 
    Invalid: COLORS.errorRed,
    Failed: COLORS.errorRed,
    Rejected: COLORS.red,
    Expired: COLORS.raspberryPink
};
